
// NATIVE 

// INSTALLED 
import { checkingPreload, unCheckingPreload } from '../loading';
import { setTerminalsRedux, storeTerminalRedux } from './terminalSlice';
import { activeTerminalService, createTerminalService, desactiveTerminalService, getTerminalDetailService, 
         getTerminalsByPaginateService, getTerminalsService, updateTerminalDetailService } from '../../services/terminals';




// CUSTOM 




export const getTerminalsStore = (): any => {

    return async( dispatch: any ) => {
       

        await dispatch( checkingPreload() );

        const result = await  getTerminalsService();

       
        if ( result.ok ) {
          await dispatch( setTerminalsRedux(result.data) );
        }

        dispatch( unCheckingPreload() );

        return result;


    }

  
}




export const getTerminalsByPagination = (page:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
  
       

      const result = await  getTerminalsByPaginateService(page);


      if ( result.ok ) {
          await dispatch( setTerminalsRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

}

export const storeCreateTerminalEmpleado = (terminal: any, percentage:any): any => {

    return async( dispatch: any ) => {


      const dataSave = {
         ...terminal,
         typeTerminal: terminal.typeTerminal.value

      }

      const result = await  createTerminalService(dataSave, percentage);

    
      if ( result.ok ) {
          await dispatch( setTerminalsRedux(result.data) );
      }

      
      return result;
        
    }
}



export const storeDetailTerminal = (terminalId: string): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      

      const result = await  getTerminalDetailService(terminalId);
    

      if ( result.ok ) {
           await dispatch( storeTerminalRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;

  }

    
}



export const storeEditTerminalEmpleados = (terminal: any): any => {
    

  return async( dispatch: any ) => { 
      

      const dataUpdate = {
         ...terminal,
         typeTerminal: terminal.typeTerminal.value,
         terminalId: terminal.terminalId
       }


      const result = await  updateTerminalDetailService(dataUpdate);
    

      if ( result.ok ) {
        await dispatch( setTerminalsRedux(result.data) );
      }


      return result;

  }

    
}





export const storeDesactiveTerminal = (terminalId: string): any => {
    

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  desactiveTerminalService(terminalId);
      
      
      if ( result.ok ) {
          await dispatch( setTerminalsRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;

  }

    
}




export const storeActiveTerminal = (terminalId: string): any => {
  

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  activeTerminalService(terminalId);


      if ( result.ok ) {
          await dispatch( setTerminalsRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;

  }

    
}